import { GetServerSideProps, NextPage } from 'next';
import { useRouter } from 'next/router';
import React from 'react';

import { PostThemeEnum } from '~/api/blog/blogTypes';
import { pagesConfigStore } from '~/atomic/atom/links/pagesConfigStore';
import { LayoutType } from '~/atomic/layout/DefaultLayout';
import { PageTemplate } from '~/atomic/organism/PageTemplate/PageTemplate';
import { BlogsPage } from '~/atomic/page/blogs/BlogsPage';
import { checkAuthToken } from '~/feature/authorization/checkAuthToken';
import { getPosts } from '~/feature/blogs/blog.data';
import { getBlogThemeFromSlug } from '~/feature/blogs/blog.slice';
import { getBlogsFilterFromUrl } from '~/feature/blogs/BlogsFilterNav/blogsFilterNav.data';
import { getPagingFromUrl } from '~/feature/pagination/pagination.data';
import { BlogTemplate } from '~/feature/template/BlogTemplate';
import { createStore, RootState } from '~/store';

const Blogs:NextPage & LayoutType = () => {
  const router = useRouter();
  const theme = router.query?.theme as PostThemeEnum;
  const themeName = getBlogThemeFromSlug(theme);

  const title = `${themeName} | Произведения авторов полностью на Bookriver`;
  const description = `${themeName} — литературно-издательская площадка Bookriver`
  + ' ⭐ Серии книг ⭐ Полные циклы произведений'
  + ' ⭐ Комментарии и отзывы читателей ⭐ Скачать произведения'
  + ' полностью в формате fb2 ✉ Найдите интересную'
  + ' книгу на нашем сайте и читайте удобно онлайн';

  return (
    <PageTemplate
      isPublic={pagesConfigStore.blogsTheme.isPublic}
      seo={{
        title,
        description,
        canonical: pagesConfigStore.blogsTheme.as(theme),
      }}
      content={(
        <BlogsPage />
      )}
    />
  );
};

Blogs.getLayout = (page) => (
  <BlogTemplate>{ page }</BlogTemplate>
);

// TODO: Вместо редиректа на 404 должна рендериться
// страница постов с заглушкой, как в остальных местах
// если эту логик убрать страница будет более оптимизирована
export const getServerSideProps: GetServerSideProps<
{ state?: RootState; },
{ theme: PostThemeEnum; }
> = async (context) => {
  const { dispatch, store } = await createStore();
  await checkAuthToken(context, dispatch);

  const theme = context.params?.theme ?? '' as PostThemeEnum;

  const themes = Object.values(PostThemeEnum);
  const isHaveThisTheme = themes.includes(theme);

  await dispatch(getPagingFromUrl(context));
  await dispatch(getBlogsFilterFromUrl(context));

  await dispatch(getPosts({ theme }));

  if (!isHaveThisTheme) {
    return { notFound: true };
  }

  const state = store.getState();
  return { props: { state } };
};

export default Blogs;
